/* eslint-disable no-unused-vars */
export const enum CartButtonEnum {
  redirect,
  trashbin,
}
